module.exports = __webpack_public_path__ + "img/icon-coffers.4c8371bc.svg";